import Swiper, { Autoplay, Lazy, Pagination } from "swiper";
import Contacts from "./template-contacts";

const Home = {
  map: null,
  init() {
    Home.events();
    Home.heroSlider();
    Home.videoAnimate();
    Contacts.renderMap();
  },

  events() {
    $(".map-zoom-in").on("click", () => {
      Home.zoomIn();
    });

    $(".map-zoom-out").on("click", () => {
      Home.zoomOut();
    });
  },

  heroSlider() {
    const heroEl = $(".hero");
    if (heroEl.length) {
      const swiper = new Swiper(heroEl.find(".hero-slider")[0], {
        modules: [Lazy, Pagination, Autoplay],
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        pagination: {
          el: heroEl.find(".swiper-pagination")[0],
          bulletElement: "button",
          clickable: true,
        },
        autoplay: {
          delay: 8000,
        },
      });

      swiper.on("slideChangeTransitionStart", () => {
        const slideId = swiper.realIndex;

        $(".hero__image").each((idx, img) => {
          $(img).fadeOut(800);

          if (idx === slideId) {
            $(img).fadeIn(800);
          }
        });
      });
    }
  },

  videoAnimate() {
    const videoWrap = $(".video-block");
    const videoEl = $(".video__visual");
    if (!videoEl.length) {
      return;
    }
    if (window.innerWidth < 900) {
      return;
    }

    $(window).on("scroll", () => {
      let offset = 0;

      const windowScroll = $(window).scrollTop();

      const bottom = windowScroll + $(window).height() - 250;
      const videoElBottom = videoEl.offset().top + videoEl.height() - 250;

      if (videoWrap.offset().top < bottom && windowScroll < videoElBottom) {
        offset = -(windowScroll - videoWrap.offset().top) / 10;
      }

      videoEl.css({
        transform: `translateY(${offset}px)`,
      });
    });
  },
};

export default Home;
